var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import { Empty, List } from 'antd';
import ListItem from '../../ListItem';
import { SearchType, SelectorMode } from '../types';
import searchNodata from '../../images/search-nodata.png';
import UserSelectionContext from '../context';
import DetailSearchBtn from './DeatilSearchBtn';
import GroupTitle from './GroupTitle';
import { filterSearchDepts, filterSearchGroups, mapSearchContacts, } from '../common';
import Loading from '../../Loading';
import arrowRightIcon from '../../images/app_ic_arrow_right.png';
import { GroupTag } from '../../Tags';
import colors from '../../style/less/colors';
import InputAreaContext from '../../UserSelectionModal/context';
// eslint-disable-next-line complexity
function SearchAllList(_a) {
    var _b = _a.searchData, searchData = _b === void 0 ? null : _b, onclick = _a.onclick, loading = _a.loading, setTabIndex = _a.setTabIndex, result = _a.result, onOrgClick = _a.onOrgClick, onGroupClick = _a.onGroupClick, searchValue = _a.searchValue, onItemCheck = _a.onItemCheck, getSearchExtraPart = _a.getSearchExtraPart, onAnalysisLog = _a.onAnalysisLog, onInputStrangerLeaveWordChange = _a.onInputStrangerLeaveWordChange;
    var _c = React.useContext(UserSelectionContext), t = _c.t, tabs = _c.tabs, frozenIds = _c.frozenIds, chooseOnlyDepart = _c.chooseOnlyDepart, canSelectDept = _c.canSelectDept, single = _c.single, canSelectStranger = _c.canSelectStranger;
    var _d = React.useContext(InputAreaContext), setNewMode = _d.setNewMode, strangerLeaveWordInput = _d.strangerLeaveWordInput;
    var contacts = searchData.contacts, depts = searchData.depts, groups = searchData.groups, hasMoreContacts = searchData.hasMoreContacts, hasMoreDepts = searchData.hasMoreDepts, hasMoreGroups = searchData.hasMoreGroups;
    // const list = mapSearchContacts(contacts, result, frozenIds, searchValue);
    // chooseOnlyDepart 只能展示部门 搜索全部去掉联系人
    var contactsData = chooseOnlyDepart
        ? []
        : mapSearchContacts(contacts, result, frozenIds, searchValue);
    var contactComp = contactsData.length ? (React.createElement("div", null,
        React.createElement(GroupTitle, { title: "\u8054\u7CFB\u4EBA" }),
        React.createElement(List, { dataSource: contactsData || [], renderItem: function (item) {
                return (React.createElement(ListItem, { disabled: item.disabled, data: item, single: single, checkable: true, onCheckChange: function (item) {
                        onclick(__assign(__assign({}, item), { name: typeof item.name === 'string'
                                ? item.name
                                : item.displayName || '', remark: typeof item.remark === 'string'
                                ? item.remark
                                : item.realRemark || '', desc: typeof item.desc === 'string'
                                ? item.desc
                                : item.realDesc || '' }));
                    }, extra: getSearchExtraPart === null || getSearchExtraPart === void 0 ? void 0 : getSearchExtraPart(item) }));
            } }),
        hasMoreContacts ? (React.createElement(DetailSearchBtn, { text: "\u67E5\u8BE2\u66F4\u591A", onClick: function () {
                setTabIndex(SearchType.Contacts);
            } })) : (canSelectStranger && (React.createElement("div", { style: { margin: '10px auto', textAlign: 'center' } },
            "\u5C1D\u8BD5\u641C\u7D22\u5173\u4E8E\u201C",
            React.createElement("span", { onClick: function () {
                    onInputStrangerLeaveWordChange === null || onInputStrangerLeaveWordChange === void 0 ? void 0 : onInputStrangerLeaveWordChange((strangerLeaveWordInput === null || strangerLeaveWordInput === void 0 ? void 0 : strangerLeaveWordInput.placeholder) || '');
                    setNewMode(SelectorMode.stranger);
                    onAnalysisLog === null || onAnalysisLog === void 0 ? void 0 : onAnalysisLog('xtbg_add_home_1637657110163', '82');
                }, style: { color: colors.primary2 } }, searchValue),
            "\u201D\u7684\u975E\u8054\u7CFB\u4EBA"))))) : null;
    var getDisabled = useCallback(function (item) {
        return frozenIds.findIndex(function (id) { return id === item.deptId; }) >= 0;
    }, [frozenIds]);
    var getDeptExtraPart = useCallback(function (deptItem) {
        if (chooseOnlyDepart || canSelectDept) {
            return (React.createElement("div", { className: deptItem.checked
                    ? "focus-user-selection-dept selection-dept-disabled"
                    : 'focus-user-selection-dept', onClick: function (event) {
                    event.stopPropagation();
                    if (!deptItem.checked) {
                        // onOrgClick(deptItem);
                        onOrgClick(__assign(__assign({}, deptItem), { name: typeof deptItem.name === 'string'
                                ? deptItem.name
                                : deptItem.displayName || '', desc: typeof deptItem.desc === 'string'
                                ? deptItem.desc
                                : deptItem.realDesc || '' }));
                        // onDeptClick(deptItem.deptId);
                    }
                } },
                React.createElement("span", { className: "focus-user-selection-dept-arrow org-dept-arrow " },
                    React.createElement("img", { src: arrowRightIcon, alt: "" }))));
        }
        return (React.createElement("span", { className: "focus-user-selection-dept-arrow", onClick: function (event) {
                onOrgClick(deptItem);
                // onDeptClick(deptItem.deptId);
                event.stopPropagation();
            } },
            React.createElement("img", { src: arrowRightIcon, alt: "" })));
    }, [canSelectDept, chooseOnlyDepart, onOrgClick]);
    // tabs 没有展示部门 搜索全部也不展示部门
    var DeptsInfoData = tabs.includes('org') || tabs.includes('workLine')
        ? filterSearchDepts(depts, result, chooseOnlyDepart || canSelectDept, frozenIds)
        : [];
    var DeptsComp = DeptsInfoData.length ? (React.createElement("div", null,
        React.createElement(GroupTitle, { title: "\u90E8\u95E8" }),
        React.createElement(List, { dataSource: DeptsInfoData || [], renderItem: function (item) {
                return (React.createElement(ListItem, { checkable: chooseOnlyDepart || canSelectDept, disabled: getDisabled(item), data: item, extra: getDeptExtraPart(item), onCheckChange: function (item) {
                        onItemCheck(item);
                    }, onClick: function (event) {
                        if (!canSelectDept || !chooseOnlyDepart) {
                            onOrgClick(item);
                        }
                    } }));
            } }),
        hasMoreDepts ? (React.createElement(DetailSearchBtn, { text: t('search.moreDepartment'), onClick: function () {
                setTabIndex(SearchType.Department);
            } })) : null)) : null;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var getExtraPart = useCallback(function (item) {
        return (React.createElement("span", { className: "focus-user-selection-dept-arrow" },
            React.createElement("img", { src: arrowRightIcon, alt: "" })));
    }, []);
    // tabs 没有展示组 搜索全部也不展示组
    var groupsData = tabs.includes('group') || tabs.includes('groupCanBeSel')
        ? filterSearchGroups(groups, frozenIds, result)
        : [];
    var groupsComp = groupsData.length ? (React.createElement("div", null,
        React.createElement(GroupTitle, { title: "\u6211\u7684\u7FA4" }),
        React.createElement(List, { dataSource: groupsData || [], renderItem: function (item) {
                var tag = React.createElement(GroupTag, { kind: item.kind, subKind: item.subKind });
                return (React.createElement(ListItem, { tag: tag, data: item, extra: tabs.includes('group') ? getExtraPart(item) : null, checkable: tabs.includes('group') ? false : true, onClick: function () {
                        if (tabs.includes('group')) {
                            onGroupClick(__assign(__assign({}, item), { name: typeof item.name === 'string'
                                    ? item.name
                                    : item.displayName || '' }));
                        }
                    }, onCheckChange: function () {
                        if (onclick) {
                            onclick(__assign(__assign({}, item), { name: typeof item.name === 'string'
                                    ? item.name
                                    : item.displayName || '' }));
                        }
                    } }));
            } }),
        hasMoreGroups ? (React.createElement(DetailSearchBtn, { text: t('search.moreGroups'), onClick: function () {
                setTabIndex(SearchType.Group);
            } })) : null)) : null;
    if (loading) {
        return (React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                minHeight: '200px',
                background: '#fff',
            } },
            React.createElement(Loading, null)));
    }
    if (!contactComp && !DeptsComp && !groupsComp) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Empty, { image: searchNodata, description: React.createElement("span", null, "\u6682\u65E0\u6570\u636E") }),
            canSelectStranger && (React.createElement("div", { style: { margin: '10px auto', textAlign: 'center' } },
                "\u5C1D\u8BD5\u641C\u7D22\u5173\u4E8E\u201C",
                React.createElement("span", { onClick: function () {
                        onInputStrangerLeaveWordChange === null || onInputStrangerLeaveWordChange === void 0 ? void 0 : onInputStrangerLeaveWordChange((strangerLeaveWordInput === null || strangerLeaveWordInput === void 0 ? void 0 : strangerLeaveWordInput.placeholder) || '');
                        setNewMode(SelectorMode.stranger);
                        onAnalysisLog === null || onAnalysisLog === void 0 ? void 0 : onAnalysisLog('xtbg_add_home_1637657110163', '82');
                    }, style: { color: colors.primary2 } }, searchValue),
                "\u201D\u7684\u975E\u8054\u7CFB\u4EBA"))));
    }
    return (React.createElement("div", { className: "search-content-wrap" },
        contactComp,
        DeptsComp,
        groupsComp)
    // <List
    //     loading={
    //         loading && {
    //             indicator: <LoadingOutlined size={16} />,
    //         }
    //     }
    //     dataSource={searchData}
    //     renderItem={(item, key) => (
    //         <ListItem
    //             data={item}
    //             onClick={() => {
    //                 if (onClick) {
    //                     onClick(SearchType.All);
    //                 }
    //             }}
    //             className="SearchListItem"
    //         />
    //     )}
    // />
    );
}
export default SearchAllList;
//# sourceMappingURL=SearchAllList.js.map